__turbopack_context__.v({
  "container": "PreOrderTotal-module-scss-module__bGrfBa__container",
});
